export default {
    win32: 0,
    darwin: 1,
    linux: 2,
};
